export default __webpack_public_path__ + "static/media/client24.77bfccc2.png";